import { useServiceSettings } from '@app/contexts/serviceSettings';
import { getFontLanguage } from '@inter-ikea-storageone/shared/utils/i18nUtils';
import { Helmet } from 'react-helmet';

const AppHelmet = () => {
  const { rangeName } = useServiceSettings();
  const fontLanguage = getFontLanguage();

  return (
    <Helmet>
      <title>{rangeName}</title>
      <link
        rel="stylesheet"
        href={`https://www.ikea.com/global/assets/fonts/${fontLanguage}/fonts.css`}
      />
    </Helmet>
  );
};

export default AppHelmet;
